/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trackingtable_Emptystate_Uploadsuffix2Inputs */

const en_trackingtable_emptystate_uploadsuffix2 = /** @type {(inputs: Trackingtable_Emptystate_Uploadsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and send deals first to see tracking information here.`)
};

/**
* | output |
* | --- |
* | "and send deals first to see tracking information here." |
*
* @param {Trackingtable_Emptystate_Uploadsuffix2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const trackingtable_emptystate_uploadsuffix2 = /** @type {((inputs?: Trackingtable_Emptystate_Uploadsuffix2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trackingtable_Emptystate_Uploadsuffix2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_trackingtable_emptystate_uploadsuffix2(inputs)
});
export { trackingtable_emptystate_uploadsuffix2 as "trackingtable_emptyState_uploadSuffix" }